import { render, staticRenderFns } from "./CalendarSchedule.vue?vue&type=template&id=23faebe0"
import script from "./CalendarSchedule.vue?vue&type=script&lang=js"
export * from "./CalendarSchedule.vue?vue&type=script&lang=js"
import style0 from "./CalendarSchedule.vue?vue&type=style&index=0&id=23faebe0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports